import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { Constants } from 'src/app/constants';
import { PalleteTypeService } from 'src/app/service/asn/pallet-type.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ShipmentsService } from 'src/app/service/document-control/shipments.service';
import { ExportStateService } from 'src/app/service/export-state.service';

@Component({
    selector: 'app-add-shipments-details',
    templateUrl: './add-shipments-details.component.html',
    styleUrls: ['./add-shipments-details.component.scss'],
    standalone: false
})
export class AddShipmentsDetailsComponent implements OnInit {

  heading: string;
  errormsg
  eventType
  partValue
  ba214
  grossWeight
  netWeight
  pallets
  sets
  freightTypeId
  invoiceNumber
  comments
  ITBond
  selected_position_id: any;
  TierData: any;
  supplierDropdown;
  freightTypeDropDown: any;
  userId: any;

  constructor(public dialogRef: MatDialogRef<AddShipmentsDetailsComponent>, private readonly constants: Constants,
    @Inject(MAT_DIALOG_DATA) public dataStore: any, private readonly shipmentDetails: ShipmentsService,
    private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly exportStateService: ExportStateService) { }

  ngOnInit(): void {
    const userData = sessionStorage?.getItem('FGA');
    if (userData)
    {
      this.userId = JSON.parse(userData)?.user?.userPrincipalName;
    }
    this.heading = this.dataStore.header;
    this.eventType = this.dataStore.eventType
    this.freightTypeDropDown = this.dataStore.freightTypeDropDown;
    if (this.eventType == 'EDIT') { // NOSONAR
      this.invoiceNumber = this.dataStore.invoiceNumber
      this.comments = this.dataStore.comments
      this.freightTypeId = this.dataStore.freightTypeId
      this.sets = this.dataStore.p_sets
      this.pallets = this.dataStore.p_pallets
      this.netWeight = this.dataStore.netWeight
      this.grossWeight = this.dataStore.grossWeight
      this.partValue = this.dataStore.partValue
      this.ITBond = this.dataStore.it
      this.ba214 = this.dataStore.ba214
    }
  }

  keyPressAlphaNumeric(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (/[.0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  keyPressNumericInvoice(event) {
    const inp = String.fromCharCode(event.keyCode);
    if (/[0-9]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  validate(event: any, module) {
    const t = event.target.value;
    if (module == "net") {  // NOSONAR
      event.target.value =
        t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 4) : t;
    } else if (module == "kg") {  // NOSONAR
      event.target.value =
        t.indexOf('.') >= 0 ? t.substr(0, t.indexOf('.')) + t.substr(t.indexOf('.'), 3) : t;
    }
  }

  close(): void {
    this.dialogRef.close(
      { event: 'CloseEvent' }
    );
  }
  onNoClick(): void {
    this.dialogRef.close({
      event: "NoEvent"
    });
  }
  public saveClick() {
    const invalid = "invalid decimal"
    this.errormsg = ""
    if (this.isValueOk(this.invoiceNumber)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.sets)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.pallets)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.grossWeight)) {
      this.showError(this.constants.formInputError);
    } else if (this.isValueOk(this.partValue)) {
      this.showError(this.constants.formInputError);
    } else if (this.netWeight?.toString().split(".").length > 2) {
      this.showError(invalid);
    } else if (this.grossWeight?.toString().split(".").length > 2) {
      this.showError(invalid);
    } else if (this.partValue?.toString().split(".").length > 2) {
      this.showError(invalid);
    } else {
      this.saveAPICall();
    }
  }

  saveAPICall() {
    this.errormsg = ""
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    const updateObject = {
      p_comments: this.comments == "" ? null : this.comments,  // NOSONAR
      p_numbers: Number(this.invoiceNumber),
      freightTypeId: Number(this.freightTypeId),
      p_sets: this.sets,
      p_pallets: this.pallets,
      netWeight: this.formatToDecimal(this.netWeight,3) ,
      grossWeight: this.formatToDecimal(this.grossWeight,3) ,
      shipmentId: this.dataStore.shipmentId,
      it: this.ITBond != null || this.ITBond != undefined ? Number(this.ITBond) : null, // NOSONAR
      ba214: this.ba214,
      partValue: this.formatToDecimal(this.partValue,2)  ,
      invoiceId: this.dataStore.invoiceId
    }
    if (this.eventType == "ADD") {  // NOSONAR
      this.shipmentDetails.addShipmentDetails(updateObject).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response == "Invoices Added Successfully") {  // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
            });
          } else {
            this.showError(response);
          }
        }, _error => {
          this.showError(this.constants.APIErrorMessage);

        });

    }
    else if (this.eventType == "EDIT") {  // NOSONAR
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)

      this.shipmentDetails.updateShipmentDetails(updateObject).subscribe(
        response => {
          if (response == "Success") {  // NOSONAR
            this.dialogRef.close({
              event: "SaveEvent",
              eventType: this.eventType,
            });
          } else {
            this.showError(this.constants.APIErrorMessage);
          }

        }, _error => {
          this.showError(this.constants.APIErrorMessage);
        });
    }

  }

  formatToDecimal(value: any, decimalPlaces: number): any {
    if (value == '' || value == undefined || value == null) {  // NOSONAR
      return null
    }

    const stringValue = value.toString();

    if (!stringValue.includes('.')) {
      return Number(stringValue);
    }

    const [integerPart, decimalPart] = stringValue.split('.');

    return Number(
      integerPart + '.' + decimalPart.substring(0, decimalPlaces)
    );
  }


  showError(message) {
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
    this.errormsg = message;
    setTimeout(() => {
      this.errormsg = ""
    }, this.constants.notificationMessageTimeShort);
  }

  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "")  // NOSONAR
    {  return true;}
    return false;
  }

  ifNullSetZero(param) {
    return Number(param ? param : 0);

  }

}
